import { ContactModel } from "./ClientModel";
import { RequestModel } from "./RequestModel";
import { TechnicianModel } from "./TechnicianModel";

import Helper, { DateFormat } from "@/services/Helper";

class ExpenseModel
{
    // copy constructor
    constructor (obj?: ExpenseModel)
    {
        if (obj)
        {
            Object.assign(this, obj);

            if (obj.ExpenseDate)
            {
                let tmp = new Date((obj.ExpenseDate + "").split("T")[0] + " 00:00:00");
                this.ExpenseDate = tmp.toUTCString();
            }            

            if (obj.Request)
            {
                this.Request = new RequestModel(obj.Request);
            }

            if (obj.Contact)
            {
                this.Contact = new ContactModel(obj.Contact);
            }

            if (obj.Technician)
            {
                this.Technician = new TechnicianModel(obj.Technician);
            }

            // fix select items
            if (this.AssignedTo === 0)
            {
                this.AssignedTo = null;
            }
        }
    }


    // extra properties for easier binding ...
    public RequestId?: number | null;

    // extra properties for easier binding ...
    public ClientId?: number | null;

    public CustomerNumber?: number | null;
    
    public Technician?: TechnicianModel | null;
    
    private _Request?: RequestModel | null;

    public get Request(): RequestModel | null | undefined
    {
        return this._Request;
    }

    public set Request(val: RequestModel | undefined)
    {
        this._Request = val;
        this.RequestId = val?.Id;
    }
    
    private _Contact?: ContactModel | null;

    public get Contact(): ContactModel | null | undefined
    {
        return this._Contact;
    }

    public set Contact(val: ContactModel | undefined)
    {
        this._Contact = val;
        this.ClientId = val?.Id;
        this.CustomerNumber = val?.CustomerNumber;
    }

    Id?: number | null;
    
    AssignedTo?: number | null;
    
    private _CreateDate?: string | null;
    
    public get CreateDate(): string | null
    {
        // return a formatted date
        return Helper.dateToInput(this.CreateDateAsDate, DateFormat.Date) || null;
    }
    
    public set CreateDate(val:string | null) 
    {
        this._CreateDate = val || null;
    }
    
    public get CreateDateAsDate(): Date | null
    {
        if (this._CreateDate)
        {
            return Helper.dateFromString(this._CreateDate);
        }

        return null;
    }
    
    public ExpenseAmount?: number | null;

    public ExpenseNotes?: string | null;
    
    private _ExpenseDate?: string | null;

    public get ExpenseDate(): string | null
    {
        // return as a formatted date
        return Helper.dateToInput(this.ExpenseDateAsDate, DateFormat.Date) || null;
    }
    
    public set ExpenseDate(val: string | null) 
    {
        // should we make sure it is formatted correctly?
        this._ExpenseDate = val || null;
    }
    
    public get ExpenseDateAsDate(): Date | null
    {
        if (this._ExpenseDate)
        {
            return Helper.dateFromString(this._ExpenseDate);
        }

        return null;
    }
    
    public ReimbursementCheckNum?: number;

    // full record count
    public RecCount?: number;
}

class ExpenseModelFilter 
{
    public Id?: Array<number> = [];

    public RequestId?: Array<number> = [];
    
    public ContactId?: Array<number> = [];
    
    public TechId?: Array<number> = [];
    
    public IncludeRequest?: boolean = false;
    
    public IncludeContact?: boolean = false;
    
    public StartDate?: Date = new Date();
    
    public EndDate?: Date = new Date();
    
    public Page?: number = 0;
    
    public Size?: number = 25;
}

export { ExpenseModel, ExpenseModelFilter };